import { Expose, Transform } from "class-transformer";
import { PointPricePositionEnum } from "@altertec_gparn/lib";

export class CreateUserDto {
  @Expose()
  username: string;

  @Expose()
  email?: string;

  @Expose()
  personalEmail?: string;

  @Transform(({ value }) => {
    const normalizedValue = typeof value === "string" ? value.trim() : value;
    return normalizedValue ? normalizedValue : undefined;
  })
  @Expose()
  internalCode?: string;

  @Expose()
  roleId?: string;

  @Expose({ name: "accessToOperativeUnitIds" })
  accessToOperativeUnits: string[];

  @Expose()
  pointPricePosition?: PointPricePositionEnum | null;
}
